<template>
	<transition name="playlist">
		<div class="playlist">
			<playlist-left/>
			<playlist-right/>
		</div>
	</transition>
</template>
<script>
import PlaylistLeft from "./PlaylistLeft";
import PlaylistRight from "./PlaylistRight";
export default {
	name: "playlist",
	components: {
		PlaylistRight,
		PlaylistLeft
	}
};
</script>
<style scoped lang="scss">
.playlist {
	width: 90%;
	right: 50%;
	transform: translateX(50%);
	max-width: 1200px;
	min-width: 550px;
	position: absolute;
	margin-top: 4rem;
	display: flex;
	height: calc(100vh - 5rem);
}

.playlist-enter-active {
	transition: all 0.5s ease;
}

.playlist-leave-active {
	transition: all 0.5s ease;
}

.playlist-enter, .playlist-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Playlist.vue